<template>
  <v-card>
    <v-card-title>
      {{ customPopupTitle }}
    </v-card-title>
    <v-card-text>
      <div v-html="customPopupContent"></div>
    </v-card-text>
    <v-card-actions class="d-flex flex-row-reverse">
      <v-btn color="primary" @click="close()"> {{ customPopupMainButtonLabel }}</v-btn>
      <v-btn v-if="customPopupSecondaryButtonLabel" text @click="close()">
        {{ customPopupSecondaryButtonLabel }}
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  name: "ParticipantCustomPopup",
  props: {
    customPopupTitle: String,
    customPopupContent: String,
    customPopupMainButtonLabel: String,
    customPopupSecondaryButtonLabel: String,
  },
  methods: {
    close() {
      this.$emit("continue");
    },
  },
};
</script>

<style scoped></style>
